<template>
  <a-modal width="35%" :label-col="4" :wrapper-col="14" :visible="open" @ok="onOk" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>配置商品购买数量折扣</b>
    </a-divider>
    <a-button  type="primary" style="width: 20%" @click="addGoodsCount()" class="margin-bottom">
      <a-icon type="plus"/>
      添加
    </a-button>
    <a-table :data-source="goodsCountDiscountList" :columns="skuColumns" :pagination="false" bordered>
      <div slot="discount" slot-scope="text, record">
        <a-input-number v-model="record.discount"
                        :min="0.01" :max="10" :step="0.01"
                        :formatter="(value) => `${value}`.replace(/\.00$/, '')"
                        :parser="(value) => value.replace(/\.00$/, '')"
                        :placeholder="$t('请输入')+'折扣'"  />
        <span>折</span>
      </div>
      <span slot="goodsCount" slot-scope="text, record">
         <a-input-number v-model="record.goodsCount"
                         style="width: 90%"
                         :min="0" :max="10000000000" :step="1"
                         :placeholder="$t('请输入')+'购买数量'"  />
                <span>内</span>
      </span>
      <div slot="discountTitle">
        折扣
        <a-tooltip>
          <template slot="title">
            <p>请输入1-10之间的数字</p>
          </template>
          <a-icon type="question-circle" />
        </a-tooltip>
      </div>
    </a-table>
  </a-modal>
</template>

<script>
import CustomDictTag from "@/components/DictCustomTag";


export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    CustomDictTag,
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      goodsCountDiscountList:[
      ],
      formTitle: '',
      previewImageVisible: false,
      previewUrl: '',
      previewVideoVisible: false,
      loading: '',
      errorMessage:undefined,
      skuColumns: [
        {
          title: '购买数量',
          dataIndex: 'goodsCount',
          scopedSlots: {customRender: 'goodsCount'},
          key: 'goodsCount',
        },
        {
          slots: { title: 'discountTitle' },
          dataIndex: 'discount',
          key: 'discount',
          scopedSlots: {customRender: 'discount'}
        }
      ],
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.goodsCountDiscountList = [
      ]
    },
    /** 修改按钮操作 */
    show(goodsCountDiscountList) {
      if (goodsCountDiscountList && goodsCountDiscountList.length > 0) {
        this.goodsCountDiscountList = goodsCountDiscountList;
      }
      this.open = true
    },
    addGoodsCount() {
      const newData = {
        goodsCount: null,
        discount: 10
      };
      this.goodsCountDiscountList.push(newData);
    },
    onOk() {
      //判断有没有选择,拿到列表里选择的
      this.open = false
      this.$emit('goodsCountDiscount', this.goodsCountDiscountList)
      this.reset()
    },
  }
}
</script>
